import { ApiService } from './ApiService';

export class PasswordResetService extends ApiService {
    protected basePath = 'reset';

    public postResetEmail(email: string): Promise<any> {
        const data = { email };
        const subPath = '';

        return this.postSubPath(subPath, data);
    }
}



// WEBPACK FOOTER //
// ./src/_services/PasswordResetService.ts